import { createContext, useContext } from 'react'

export type ToastTone = 'info' | 'success' | 'danger'

export interface ToastOptions {
  tone?: ToastTone
  /** Миллисекунды до автозакрытия. 0 — не закрывать само. */
  duration?: number
  action?: { label: string; onClick: () => void }
}

export interface ToastApi {
  show: (message: string, options?: ToastOptions) => void
  success: (message: string, options?: ToastOptions) => void
  error: (message: string, options?: ToastOptions) => void
}

export const ToastContext = createContext<ToastApi | null>(null)

export function useToast(): ToastApi {
  const api = useContext(ToastContext)
  if (!api) throw new Error('useToast вызван вне <ToastProvider>')
  return api
}
